import { Attribute, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'
import { SistemaDesktop } from './controle-versao/sistema-desktop.enum'
import { SistemaWeb } from './controle-versao/sistema-web.enum'
import { VersaoDesktop } from './controle-versao/versao-desktop'
import { VersaoWeb } from './controle-versao/versao-web'
import { VersoesDesktopConverter } from './converters/versoes-desktop.converter'
import { VersoesWebConverter } from './converters/versoes-web.converter'
import { Pacote } from './pacote.model'

@JsonApiModelConfig({
    type: 'user-connections',
})
export class UserConnection extends JsonApiModel {
    @Attribute() nomeCurto: string
    @Attribute() nome: string
    @Attribute() email: string
    @Attribute() crm: number
    @Attribute() inscricaoFederal: number
    @Attribute() karoo: string
    @Attribute() ativo: boolean

    @Attribute() crmer: boolean
    @Attribute() cnder: boolean
    @Attribute() karooer: boolean
    @Attribute() tarefer: boolean
    @Attribute() tareferWeb: boolean
    @Attribute() auditer: boolean
    @Attribute() collecter: boolean

    @Attribute() freemium: boolean

    @Attribute({ converter: new VersoesWebConverter() })
    versoesWeb: VersaoWeb[]
    @Attribute({ converter: new VersoesDesktopConverter() })
    versoesDesktop: VersaoDesktop[]

    @Attribute() pacote: Pacote

    @Attribute() isPilotoTarefas: boolean

    @Attribute() utilizaeExtrato: boolean

    @Attribute() recursosEmFasePiloto: Array<any>;

    @Attribute() utilizaRadarEcac: boolean
    
    get possuiPackCrm() {
        return this.crmer
    }

    get possuiPackCnd() {
        return this.cnder
    }

    get possuiKaroo() {
        return this.karooer
    }

    get possuiPackTarefas() {
        return this.tarefer
    }

    get possuiAudit() {
        return this.auditer
    }

    get possuiCollect() {
        return this.collecter
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/user-connection.model.ts